/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cloud_Storage_Announcement_TitleInputs */

const en_cloud_storage_announcement_title = /** @type {(inputs: Cloud_Storage_Announcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive and Dropbox are here`)
};

const es_cloud_storage_announcement_title = /** @type {(inputs: Cloud_Storage_Announcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive y Dropbox ya están aquí`)
};

/**
* | output |
* | --- |
* | "Google Drive and Dropbox are here" |
*
* @param {Cloud_Storage_Announcement_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cloud_storage_announcement_title = /** @type {((inputs?: Cloud_Storage_Announcement_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cloud_Storage_Announcement_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cloud_storage_announcement_title(inputs)
	return en_cloud_storage_announcement_title(inputs)
});